<template>
  <v-row v-if="areBuypassSettingsVisible">
    <v-col cols="12">
      <h3 class="text-h3 mt-8 mb-5">
        {{ $t("generalSettingsStrings.buypassSettings.title") }}
      </h3>
      <v-switch
        v-model="orgConfiguration.buypassSettings.isActive"
        color="primary"
        inset
        :label="
          $t('generalSettingsStrings.buypassSettings.labels.isActive')
        "
        :disabled="!isBuypassAdminForCurrentOrg"
      />
      <v-row v-if="isBuypassAdminForCurrentOrg">
        <v-col
          cols="12"
          sm="6"
          md="3"
        >
          <vee-field
            v-slot="{ componentField, errors }"
            v-model="orgConfiguration.buypassSettings.settlementAccountId"
            :rules="{
              required_if: orgConfiguration.buypassSettings.isActive,
            }"
            :name="$t('generalSettingsStrings.buypassSettings.labels.settlementAccountId')"
          >
            <v-select
              v-bind="componentField"
              :items="availableBuypassAccounts"
              item-value="settlementAccountId"
              item-title="name"
              :label="
                $t(
                  'generalSettingsStrings.buypassSettings.labels.settlementAccountId'
                )
              "
              :placeholder="
                $t(
                  'generalSettingsStrings.buypassSettings.placeholders.settlementAccountId'
                )
              "
              :error-messages="errors"
              variant="outlined"
              density="compact"
            />
          </vee-field>
        </v-col>
      </v-row>
      <em v-else>{{ $t('generalSettingsStrings.buypassSettings.editNotAvailableMessage') }}</em>
      <div class="mt-2">
        <buypass-settings-info-modal />
      </div>
    </v-col>
  </v-row>
</template>

<script>
import BuypassSettingsInfoModal from "./BuypassSettingsInfoModal";
import { mapGetters } from "vuex";
import { api } from "@/utils/api";
import { Field as VeeField } from "vee-validate";
import { handleError } from "@/utils/errorHandler";
import { useBuypass } from "@/composables/buypass";

export default {
  name: "BuypassSettings",
  components: {
      BuypassSettingsInfoModal,
      VeeField
  },
  props: {
    orgConfiguration: {
      required: true,
      validator: prop => typeof prop === "object" || !prop
    },
    relationActivationRights: {
      required: true,
      validator: prop => typeof prop === "object" || !prop
    },
    orgId: Number
  },
  setup() {
    const { isBuypassAdminForCurrentOrg } = useBuypass();
    return { isBuypassAdminForCurrentOrg };
  },
  data() {
    return {
      availableBuypassAccounts: []
    };
  },
  computed: {
    ...mapGetters({
      orgsWithPermissions: "currentOrgsStore/orgs"
    }),
    currentOrgWithPermissions() {
      if (this.orgsWithPermissions && this.orgId) {
        return this.orgsWithPermissions.find(x => x.org.id === this.orgId);
      }

      return null;
    },
    areBuypassSettingsVisible() {
      return this.relationActivationRights.areBuypassSettingsPermitted;
    },
    canGetBuypassAccounts() {
      return this.isBuypassAdminForCurrentOrg && this.areBuypassSettingsVisible;
    }
  },
  watch: {
    canGetBuypassAccounts: {
      async handler(val) {
        if (val) {
          await this.fetchBuypassAccounts();
        }
      },
      immediate: true
    },
    orgId: {
      handler(orgId) {
        this.buypassOrgId = orgId;
      },
      immediate: true
    }
  },
  methods: {
    async fetchBuypassAccounts() {
      try {
        const response = await api.v1.orgs.buypassSettlementAccounts(
          this.orgId
        );
        if (response.status === 200) {
          this.availableBuypassAccounts = response.data;
        }
      } catch (error) {
        await handleError(error);
      }
    }
  }
};
</script>